import {mapGetters, mapActions} from 'vuex'
import {latLng} from 'leaflet'
import {LMap, LTileLayer, LMarker, LTooltip} from 'vue2-leaflet'
import {equal} from '@/utils/object'

import pois from '@/data/pois'

const DEFAULT_CENTER = latLng(-0.599094, 117.504444)

export default {
  name: 'PoiMapPage',
  data () {
    return {
      zoom: 5,
      center: DEFAULT_CENTER,
      url: "http://{s}.tile.osm.org/{z}/{x}/{y}.png",
      attribution:
        '&copy; <a href="http://osm.org/copyright">OpenStreetMap</a> contributors',
      marker: DEFAULT_CENTER,
      mapOptions: {
        zoomSnap: 0.5
      },
      currentZoom: 0,
      currentCenter: 0,
      poi: ''
    }
  },
  mounted () {
    this.init()
  },
  components: {
    LMap,
    LTileLayer,
    LMarker,
    LTooltip
  },
  computed: {
    ...mapGetters(['visibleSideBar']),
    ...mapGetters('Damage', ['damages']),
    pois () {
      return pois
    },
    type () {
      return this.$route.params.type
    },
    code () {
      return this.$route.params.code
    },
    currentPoi () {
      const [type, code] = this.poi.toLowerCase().split(',')
      return {
        type,
        code
      }
    }
  },
  methods: {
    ...mapActions('Damage', {
      fetchDamages: 'fetch'
    }),
    zoomUpdate(zoom) {
      this.currentZoom = zoom
    },
    centerUpdate(center) {
      this.currentCenter = center
      this.marker = center
    },
    init () {
      this.currentZoom = this.zoom
      this.currentCenter = this.center

      this.setPoi()
    },
    getLatLng (str) {
      return latLng(...str.split(','))
    },
    getStatus (code) {
      return this.statusMapped[code] || {}
    },
    setPoi () {
      this.poi = (this.type + ',' + this.code).toUpperCase()
    }
  },
  watch: {
    currentPoi (v, ov) {
      if (!ov.type || equal(v, ov)) return
      this.$router.push({
        params: this.currentPoi
      })
    }
  }
}